import React, {useState} from "react";
import { Table, Button, Tooltip } from "antd";
import { FileTextOutlined, CheckCircleTwoTone } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import { approveTransfer, fetchTransferPendingRecord } from "../TransferPendingRecordThunk";
import { formatToCompanyTimezone } from "../../../lib/functions";

const TransferPendingRecordTable = ({ printMode = false }) => {
  const navigate = useNavigate();
  const { list, loading, filters } = useSelector((s) => s.transferPendingRecord);
  const authInfo = useSelector((s) => s.auth.userInfo || s.auth); // in case stored differently
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };
  const handleViewVoucher = (record) => {
    navigate(`/inventory/quick-transfer-voucher/${record.id}`);
  };

  


const handleApprove = (record) => {
  const t_id = record.id;

  Modal.confirm({
    title: "Approve Transfer?",
    content: `Voucher No: ${record.vch_no}`,
    okText: "Approve",
    cancelText: "Cancel",
    okButtonProps: { type: "primary", danger: true },
    onOk: async () => {
      const res = await dispatch(approveTransfer(t_id));

      // Only refresh if approval succeeded
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          fetchTransferPendingRecord({
            selectedFilterType: filters.filterType,
            selectedRecordType: filters.recordType,
            filters,
          })
        );
      }
    },
  });
};


  const canApprove = authInfo?.acc_type !== "user";

  const baseColumns = [
    { title: "No.", render: (_, __, i) => i + 1, width: 60 },
    { title: "Voucher No", dataIndex: "vch_no" },
    { title: "Date", dataIndex: "date", render: (v) =>
    v ? formatToCompanyTimezone(v).split(" ")[0] : "-", },
    { title: "To Branch", dataIndex: "branch" },
    { title: "Transfer By", dataIndex: "createdBy" },
    {
      title: "Transport Cost",
      dataIndex: "transport_cost",
      align: "right",
      render: (v) => Number(v || 0).toFixed(2),
    },
    {
      title: "Total",
      dataIndex: "total",
      align: "right",
      render: (v) => Number(v || 0).toFixed(2),
    },
    !printMode && {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          <Tooltip title="View Voucher">
            <Button
              type="text"
              icon={<FileTextOutlined style={{ color: "#1677ff" }} />}
              onClick={() => handleViewVoucher(record)}
            />
          </Tooltip>

          {canApprove && (
            <Tooltip title="Approve">
              <Button
                type="text"
                icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
                onClick={() => handleApprove(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ].filter(Boolean);

  // Expand item rows
  const expandable =
    filters.recordType === "with item"
      ? {
          expandedRowRender: (record) =>
            record.details?.length ? (
              <Table
                size="small"
                pagination={false}
                rowKey={(r) => r.t_d_id}
                columns={[
                  { title: "Item", dataIndex: "item_name" },
                  {
                    title: "Qty",
                    dataIndex: "item_qty",
                    render: (_, r) =>
                      `${r.item_qty} ${r.unit_name || ""}${
                        r.retail_qty ? `, ${r.retail_qty} ${r.base_unit_name}` : ""
                      }`,
                  },
                  {
                    title: "Total",
                    dataIndex: "item_total",
                    align: "right",
                    render: (v) => Number(v || 0).toFixed(2),
                  },
                ]}
                dataSource={record.details}
              />
            ) : null,
        }
      : undefined;

  return (
    <div style={printMode ? undefined : { overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
    <Table
      rowKey="id"
      columns={baseColumns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      expandable={expandable}
      scroll={printMode ? undefined : { x: "max-content" }}
      size={printMode ? "small" : "middle"}
      summary={(pageData) => {
        let total = 0;
        let trans = 0;
        pageData.forEach((d) => {
          total += Number(d.total || 0);
          trans += Number(d.transport_cost || 0);
        });

        return (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5} style={{ fontWeight: 700 }}>
              Total
            </Table.Summary.Cell>
            <Table.Summary.Cell align="right" index={1} style={{ fontWeight: 700 }}>
              {trans.toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell align="right" index={2} style={{ fontWeight: 700 }}>
              {total.toFixed(2)}
            </Table.Summary.Cell>
            {!printMode && <Table.Summary.Cell />}
          </Table.Summary.Row>
        );
      }}
    />
    </div>
  );
};

export default TransferPendingRecordTable;
